import React from 'react';

import { useMsal } from '@azure/msal-react';

import Button from 'components/Button/Button';

import { loginRequest } from '../../../config/msalConfig';
import { ELoginAuthMethod, LoginData } from '../../LoginModal/LoginModal.types';
import { ZENDESK_DOMAIN } from '../constants';
import { GoogleLoginProps } from '../LoginForm.types';

export const MicrosoftLogin = ({ login, onLoginFailed }: GoogleLoginProps) => {
  const { instance } = useMsal();
  const [isLoading, setIsLoading] = React.useState(false);

  const handleMicrosoftLogin = async () => {
    try {
      setIsLoading(true);

      const searchParams = new URLSearchParams(window.location.search);
      const origin = searchParams.get('brand_id') || '';
      const returnTo = searchParams.get('return_to') || '';
      const isZendesk = !!origin || window.location.hostname === ZENDESK_DOMAIN;

      const response = await instance.loginPopup(loginRequest);

      const tokenResponse = await instance.acquireTokenSilent({
        ...loginRequest,
        account: response.account
      });

      const loginData: LoginData = {
        loginToken: tokenResponse.accessToken,
        rememberMe: true
      };

      login(
        loginData,
        (success: boolean) => {
          setIsLoading(false);
          if (success) {
            if (isZendesk && returnTo) {
              return;
            }
            return;
          }
          onLoginFailed();
        },
        ELoginAuthMethod.MICROSOFT
      );

    } catch (error: any) {
      setIsLoading(false);
      console.error('Microsoft login error:', error);

      if (error.errorCode === 'user_cancelled') {
        return;
      }

      if (error.errorCode === 'popup_window_error') {
        try {
          await instance.loginRedirect(loginRequest);
          return;
        } catch (redirectError) {
          console.error('Microsoft redirect login error:', redirectError);
        }
      }

      onLoginFailed();
    }
  };

  return (
    <Button
      variant="outline"
      onClick={handleMicrosoftLogin}
      disabled={isLoading}
      className="w-full shadow-sm mt-4"
      leftIcon={
        <img
          className="w-4 h-4"
          src="/assets/icons/ac-microsoft-icon.png"
          alt="microsoft icon"
        />
      }
    >
      {isLoading ? 'Signing in...' : 'Continue with Microsoft'}
    </Button>
  );
}; 